import { PkgShippingMethod } from '@/api/user-package/types/UserPkg'

export type ShippingPrices =
  | Record<PkgShippingMethod, number>
  | { [PkgShippingMethod.DoorToDoor]: number; [PkgShippingMethod.PickUpPoint]?: number }

export interface PriceChart {
  weight: number
  price: ShippingPrices
}

export const priceChartGR: PriceChart[] = [
  { weight: 1, price: { pickUpPoint: 20, doorToDoor: 26 } },
  { weight: 1.5, price: { pickUpPoint: 25, doorToDoor: 30 } },

  { weight: 2, price: { pickUpPoint: 29, doorToDoor: 35 } },
  { weight: 2.5, price: { pickUpPoint: 34, doorToDoor: 39 } },

  { weight: 3, price: { pickUpPoint: 38, doorToDoor: 43 } },
  { weight: 3.5, price: { pickUpPoint: 43, doorToDoor: 48 } },

  { weight: 4, price: { pickUpPoint: 47, doorToDoor: 52 } },
  { weight: 4.5, price: { pickUpPoint: 51, doorToDoor: 57 } },

  { weight: 5, price: { pickUpPoint: 56, doorToDoor: 61 } },

  { weight: 6, price: { doorToDoor: 70 } },
  { weight: 7, price: { doorToDoor: 79 } },
  { weight: 8, price: { doorToDoor: 88 } },
  { weight: 9, price: { doorToDoor: 96 } },
  { weight: 10, price: { doorToDoor: 105 } },
  { weight: 11, price: { doorToDoor: 117 } },
  { weight: 12, price: { doorToDoor: 126 } },
  { weight: 13, price: { doorToDoor: 134 } },
  { weight: 14, price: { doorToDoor: 143 } },

  { weight: 15, price: { doorToDoor: 152 } },
  { weight: 16, price: { doorToDoor: 161 } },
  { weight: 17, price: { doorToDoor: 170 } },
  { weight: 18, price: { doorToDoor: 179 } },
  { weight: 19, price: { doorToDoor: 187 } },
  { weight: 20, price: { doorToDoor: 196 } },

  { weight: 21, price: { doorToDoor: 205 } },
  { weight: 22, price: { doorToDoor: 214 } },
  { weight: 23, price: { doorToDoor: 223 } },
  { weight: 24, price: { doorToDoor: 232 } },
  { weight: 25, price: { doorToDoor: 241 } },
  { weight: 26, price: { doorToDoor: 250 } },
  { weight: 27, price: { doorToDoor: 259 } },
  { weight: 28, price: { doorToDoor: 268 } },
  { weight: 29, price: { doorToDoor: 277 } },
  { weight: 30, price: { doorToDoor: 286 } },
]

export const priceChartUSA = [
  { weight: 1, price: { pickUpPoint: 22, doorToDoor: 28 } },
  { weight: 1.5, price: { pickUpPoint: 27, doorToDoor: 33 } },

  { weight: 2, price: { pickUpPoint: 32, doorToDoor: 38 } },
  { weight: 2.5, price: { pickUpPoint: 37, doorToDoor: 43 } },

  { weight: 3, price: { pickUpPoint: 42, doorToDoor: 48 } },
  { weight: 3.5, price: { pickUpPoint: 47, doorToDoor: 53 } },

  { weight: 4, price: { pickUpPoint: 52, doorToDoor: 58 } },
  { weight: 4.5, price: { pickUpPoint: 57, doorToDoor: 63 } },

  { weight: 5, price: { pickUpPoint: 62, doorToDoor: 68 } },

  { weight: 6, price: { doorToDoor: 73 } },
  { weight: 7, price: { doorToDoor: 78 } },
  { weight: 8, price: { doorToDoor: 86 } },
  { weight: 9, price: { doorToDoor: 94 } },
  { weight: 10, price: { doorToDoor: 103 } },
  { weight: 11, price: { doorToDoor: 112 } },
  { weight: 12, price: { doorToDoor: 121 } },
  { weight: 13, price: { doorToDoor: 130 } },
  { weight: 14, price: { doorToDoor: 139 } },

  { weight: 15, price: { doorToDoor: 148 } },
  { weight: 16, price: { doorToDoor: 157 } },
  { weight: 17, price: { doorToDoor: 166 } },
  { weight: 18, price: { doorToDoor: 175 } },
  { weight: 19, price: { doorToDoor: 184 } },
  { weight: 20, price: { doorToDoor: 193 } },

  { weight: 21, price: { doorToDoor: 202 } },
  { weight: 22, price: { doorToDoor: 211 } },
  { weight: 23, price: { doorToDoor: 220 } },
  { weight: 24, price: { doorToDoor: 229 } },
  { weight: 25, price: { doorToDoor: 238 } },
  { weight: 26, price: { doorToDoor: 247 } },
  { weight: 27, price: { doorToDoor: 256 } },
  { weight: 28, price: { doorToDoor: 265 } },
  { weight: 29, price: { doorToDoor: 274 } },
  { weight: 30, price: { doorToDoor: 283 } },
]

export const priceChartUK = [
  { weight: 1, price: { pickUpPoint: 24, doorToDoor: 30 } },
  { weight: 1.5, price: { pickUpPoint: 29, doorToDoor: 35 } },

  { weight: 2, price: { pickUpPoint: 34, doorToDoor: 40 } },
  { weight: 2.5, price: { pickUpPoint: 38, doorToDoor: 45 } },

  { weight: 3, price: { pickUpPoint: 43, doorToDoor: 49 } },
  { weight: 3.5, price: { pickUpPoint: 48, doorToDoor: 54 } },

  { weight: 4, price: { pickUpPoint: 53, doorToDoor: 59 } },
  { weight: 4.5, price: { pickUpPoint: 57, doorToDoor: 64 } },

  { weight: 5, price: { pickUpPoint: 62, doorToDoor: 68 } },

  { weight: 6, price: { doorToDoor: 78 } },
  { weight: 7, price: { doorToDoor: 87 } },
  { weight: 8, price: { doorToDoor: 97 } },
  { weight: 9, price: { doorToDoor: 106 } },
  { weight: 10, price: { doorToDoor: 116 } },
  { weight: 11, price: { doorToDoor: 128 } },
  { weight: 12, price: { doorToDoor: 138 } },
  { weight: 13, price: { doorToDoor: 147 } },
  { weight: 14, price: { doorToDoor: 157 } },

  { weight: 15, price: { doorToDoor: 166 } },
  { weight: 16, price: { doorToDoor: 176 } },
  { weight: 17, price: { doorToDoor: 185 } },
  { weight: 18, price: { doorToDoor: 195 } },
  { weight: 19, price: { doorToDoor: 204 } },
  { weight: 20, price: { doorToDoor: 214 } },
]

export const priceChartUAE = [
  { weight: 1, price: { pickUpPoint: 24, doorToDoor: 30 } },
  { weight: 1.5, price: { pickUpPoint: 30, doorToDoor: 36 } },

  { weight: 2, price: { pickUpPoint: 37, doorToDoor: 43 } },
  { weight: 2.5, price: { pickUpPoint: 45, doorToDoor: 50 } },

  { weight: 3, price: { pickUpPoint: 50, doorToDoor: 56 } },
  { weight: 3.5, price: { pickUpPoint: 57, doorToDoor: 63 } },

  { weight: 4, price: { pickUpPoint: 64, doorToDoor: 70 } },
  { weight: 4.5, price: { pickUpPoint: 70, doorToDoor: 77 } },

  { weight: 5, price: { pickUpPoint: 78, doorToDoor: 84 } },

  { weight: 6, price: { doorToDoor: 97 } },
  { weight: 7, price: { doorToDoor: 110 } },
  { weight: 8, price: { doorToDoor: 124 } },
  { weight: 9, price: { doorToDoor: 137 } },
  { weight: 10, price: { doorToDoor: 150 } },
  { weight: 11, price: { doorToDoor: 167 } },
  { weight: 12, price: { doorToDoor: 180 } },
  { weight: 13, price: { doorToDoor: 194 } },
  { weight: 14, price: { doorToDoor: 208 } },

  { weight: 15, price: { doorToDoor: 220 } },
  { weight: 16, price: { doorToDoor: 235 } },
  { weight: 17, price: { doorToDoor: 248 } },
  { weight: 18, price: { doorToDoor: 262 } },
  { weight: 19, price: { doorToDoor: 275 } },
  { weight: 20, price: { doorToDoor: 290 } },
]
